import { createFileRoute, Outlet } from '@tanstack/react-router';
import { requireSession } from '../../auth/require-session.js';
import { SessionError, SessionPending } from '../../auth/SessionStates.js';

/** `/types` (1.B-2): the layout of the Types pages, guarded as `/` is. */
export const Route = createFileRoute('/types')({
  beforeLoad: async ({ location }) => ({ me: await requireSession(location.pathname) }),
  pendingComponent: SessionPending,
  pendingMs: 0,
  pendingMinMs: 0,
  errorComponent: SessionError,
  staticData: { crumb: 'Types' },
  component: Outlet,
});
